export default __webpack_public_path__ + "static/media/Horseback-Ride-e1577992287766.9cde5121.jpeg";